import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const lookupCustomReportId = unaryRpc({
  name: "lookupCustomReportId" as const,
  input: z.object({ id: z.string().trim().min(1) }),
  output: z.object({
    valid: z.boolean(),
    rowId: z.string().nullable(),
    publicId: z.string().nullable(),
    found: z.boolean(),
    error: z.string().nullable(),
    report: z
      .object({
        teamId: z.string(),
        title: z.string().nullable(),
        status: z.enum(["preparing", "ready", "failed"]),
        requestedQuestion: z.string(),
        createdAt: z.date(),
        updatedAt: z.date(),
      })
      .nullable(),
  }),
});

export type LookupCustomReportIdInput = z.infer<
  typeof lookupCustomReportId.input
>;
export type LookupCustomReportIdOutput = z.infer<
  typeof lookupCustomReportId.output
>;
